import { environment } from '@shared/environment/environment';
import { PropertyMedia } from './../../Estate';
export const defaultImageOnNotImageFound =
  'https://cdn.aptuno.com/properties-images/928/e715acf1-86dc-499a-9cbf-8517d0f91217.jpg';

export const parseImages = (image, size = 'main', type = 'jpg') => {
  const basePre = environment.gcpStorage.baseUrl;
  const basePost = environment.gcpStorage.cdnBaseUrl;

  if (!!image) {
    const cdnImageLink = image && image.replace(basePre, basePost);
    const resourceUriWithOutExtension = cdnImageLink.replace(/\.jpg/i, '');

    return size === 'thumb' ? `${resourceUriWithOutExtension}_thumb.${type}` : cdnImageLink;
  } else {
    return defaultImageOnNotImageFound;
  }
};

export const getMainImage = (images: PropertyMedia[]): PropertyMedia => {
  return images.find((image) => image.main) || images[0];
};
